import { cdnUrl } from 'commons/cdn'
import { MyImage } from 'components/MyImage'
import { MyMedia } from 'components/MyMedia'

const DEFAULT_TILE = 'h-32 w-32 shrink-0'

interface MediaTileProps {
  title: string
  type: 'image' | 'video'
  url?: string
  fallbackImageUrl?: string
  tileClassName?: string
}

function MediaTile({
  title,
  type,
  url,
  fallbackImageUrl,
  tileClassName = DEFAULT_TILE,
}: MediaTileProps) {
  const hasUrl = !!url?.trim()

  return (
    <div className="space-y-1">
      <div className="text-[10px] text-muted-foreground">{title}</div>
      {hasUrl ? (
        type === 'image' ? (
          <MyImage
            src={cdnUrl(url!)}
            alt={title}
            className={`${tileClassName} rounded-md border border-border bg-black object-contain object-center`}
          />
        ) : (
          <MyMedia
            alt={title}
            videoUrl={url}
            imageUrl={fallbackImageUrl}
            lazyVideo={false}
            videoFit="contain"
            className={`${tileClassName} rounded-md border border-border`}
          />
        )
      ) : (
        <div
          className={`${tileClassName} flex items-center justify-center rounded-md border border-dashed border-border bg-muted/50 text-[10px] text-muted-foreground`}
        >
          无
        </div>
      )}
    </div>
  )
}

interface TemplateInitDataInfoDisplayProps {
  cover?: string
  videoCover?: string
  videoCoverPreview?: string
  preview?: string
  videoPreview?: string
  videoPreviewPreview?: string
  /** 默认 h-32 w-32；draft 审核等场景可传更大尺寸 */
  tileClassName?: string
}

/** Info 面板：Cover / Preview 各 3 项（静态图 + 原视频 + 缩略视频） */
export function TemplateInitDataInfoDisplay({
  cover,
  videoCover,
  videoCoverPreview,
  preview,
  videoPreview,
  videoPreviewPreview,
  tileClassName,
}: TemplateInitDataInfoDisplayProps) {
  return (
    <div className="flex flex-col gap-6 sm:flex-row sm:flex-wrap">
      <div className="space-y-2">
        <div className="text-xs font-medium text-muted-foreground">Cover (Cover 的缩略图时常推荐10秒)</div>
        <div className="flex flex-wrap gap-3">
          <MediaTile title="cover" type="image" url={cover} tileClassName={tileClassName} />
          <MediaTile
            title="videoCover"
            type="video"
            url={videoCover}
            fallbackImageUrl={cover}
            tileClassName={tileClassName}
          />
          <MediaTile
            title="videoCoverPreview"
            type="video"
            url={videoCoverPreview}
            fallbackImageUrl={cover}
            tileClassName={tileClassName}
          />
        </div>
      </div>

      <div className="space-y-2">
        <div className="text-xs font-medium text-muted-foreground">Preview</div>
        <div className="flex flex-wrap gap-3">
          <MediaTile title="preview" type="image" url={preview} tileClassName={tileClassName} />
          <MediaTile
            title="videoPreview"
            type="video"
            url={videoPreview}
            fallbackImageUrl={preview}
            tileClassName={tileClassName}
          />
          <MediaTile
            title="videoPreviewPreview"
            type="video"
            url={videoPreviewPreview}
            fallbackImageUrl={preview}
            tileClassName={tileClassName}
          />
        </div>
      </div>
    </div>
  )
}
